export default function XSLT_If() {
  return (
    <div>
      <h1>XSLT_If</h1>
      <p>This is the XSLT_If component.</p>
    </div>
  );
}